// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../node_modules/less-loader/dist/cjs.js!../base/GodsAndKings.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CjtDayRTpW9YEwhBAC1g {
}
/* Non-VIP panel icon sits 8px further left than the VIP one */
.CjtDayRTpW9YEwhBAC1g div[data-type='panelIcon'] {
  right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/variants/GodsAndKings/GodsAndKings.module.css"],"names":[],"mappings":"AAAA;AAEA;AACA,8DAA8D;AAC9D;EACE,UAAU;AACZ","sourcesContent":[".godsAndKingsTheme {\n  composes: godsAndKingsTheme from '../base/GodsAndKings.base.module.css';\n}\n/* Non-VIP panel icon sits 8px further left than the VIP one */\n.godsAndKingsTheme div[data-type='panelIcon'] {\n  right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"godsAndKingsTheme": `CjtDayRTpW9YEwhBAC1g ${___CSS_LOADER_ICSS_IMPORT_0___.locals["godsAndKingsTheme"]}`
};
export default ___CSS_LOADER_EXPORT___;
